/**
 * Stage Progression (Phase C, C-3)
 *
 * Zod schema for the per-record deal-stage progression stored in
 * records_metadata.crm_stage_progression (migration 063, @aica/database
 * RecordMetadataBaseRepository.updateStageProgression). One value per
 * RECORD (not per series, unlike callSeriesOutcomeSemanticSchema) — computed
 * once by the outcome-sync cron (Phase C, C-2/C-3) by comparing the Phase B
 * baseline snapshot (records_metadata.crm_stage_id at call time) against the
 * deal's stage at a fixed 7-day evaluation window after the call.
 *
 * A third, DIFFERENT axis from crmStageSemanticSchema (7-value pipeline
 * PHASE, ./records) and callSeriesOutcomeSemanticSchema (3-value deal
 * OUTCOME, ./call-series-outcomes) — this one is "did the deal move, and
 * which way" relative to where it was at call time, not where it sits or
 * whether it closed.
 *
 * - `advanced`: the deal moved to a later stage (higher SORT in the same
 *   pipeline, or reached a terminal WON stage) by the window's end
 * - `held`: the deal was in the same stage at the window's end (includes
 *   the conservative default for unresolvable/cross-pipeline comparisons —
 *   see resolveStageProgression in @aica/connectors)
 * - `regressed`: the deal moved to an earlier stage (lower SORT in the same
 *   pipeline, or reached a terminal LOST stage) by the window's end
 */
import { z } from 'zod/v4';

export const crmStageProgressionSchema = z.enum(['advanced', 'held', 'regressed']);

export const CRM_STAGE_PROGRESSIONS = crmStageProgressionSchema.options;

export type CrmStageProgression = z.infer<typeof crmStageProgressionSchema>;
